import { AdminPanelSettings } from "@mui/icons-material";

const Card = ({ image, title, description, link }) => {
  return (
    <a className="card" href={link} target="_blank">
      <div className="card-image">
        {image ? <img src={image} /> : <AdminPanelSettings fontSize="large" />}
      </div>
      <div className="card-info">
        <h2 className="card-title">{title}</h2>
        <p className="card-description">{description}</p>
      </div>
    </a>
  );
};

export default Card;
